import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Tooltip } from "../Components";
import * as SC from "./Campaign__Create_DraftjsViewer.styled";
import { getRandomId } from "../utils";

const DraftjsViewer = ({ html, onClick }) => {
  const { t } = useTranslation();

  const checkEmptyHTML = (html) => {
    let div = document.createElement("div");
    div.innerHTML = html;
    let text = div.textContent || div.innerText || "";
    return text === "";
  };

  const tooltipId = useMemo(() => getRandomId(), []);

  return (
    <SC.Container onClick={onClick} isEmpty={checkEmptyHTML(html)}>
      <div dangerouslySetInnerHTML={{ __html: html }} data-tip="" data-for={tooltipId}></div>
      <SC.EmptyView className="empty-view">{t("Please insert job posting text")}</SC.EmptyView>
      <Tooltip
        id={tooltipId}
        effect="solid"
        place="top"
        backgroundColor="#1C1928"
        offset={{ top: -5 }}
      >
        <span>{t("Click to edit text")}</span>
      </Tooltip>
    </SC.Container>
  );
};
export default DraftjsViewer;
